export default __webpack_public_path__ + "static/barfplan-blog-promo-small@1x-980605e6f1c81792143f6905f22a9b27.png";